/**
 * Created by neo on 18.12.20.
 */
import { makeAutoObservable } from 'mobx';

export type Nutrient = {
  amount: number;
  unit: string;
};

export function createNutrient(json?: Partial<Nutrient>): Nutrient {
  return makeAutoObservable({
    amount: json?.amount ?? 0,
    unit: json?.unit ?? '',
  });
}
